import { ErrorHandler, Injectable } from "@angular/core";
import { AppInsightsService } from "@modules/common/services/app-insights.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    constructor(
        private readonly _appInsightsService: AppInsightsService
    ) { }

    public handleError(error: any): void {
        console.error(error);
        this._appInsightsService.trackException(error);
    }
}